var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStarfilled = function SvgStarfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m11.104 1.799 1.828 3.65c.179.359.524.607.925.665l4.088.588c1.01.146 1.412 1.37.681 2.072l-2.956 2.84c-.29.28-.423.68-.354 1.075l.698 4.01c.172.992-.884 1.75-1.787 1.28l-3.654-1.895a1.248 1.248 0 0 0-1.146 0L5.773 17.98c-.903.47-1.959-.288-1.786-1.28l.697-4.01a1.203 1.203 0 0 0-.354-1.075l-2.956-2.84c-.731-.702-.33-1.926.68-2.072l4.089-.588c.4-.058.747-.306.926-.665L8.896 1.8c.452-.903 1.756-.903 2.208 0Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgStarfilled;